export default {
    ...process.env,
    CHAIN: {
        "magic": "testnet.aergo.io",
        "public": true,
        "mainnet": false,
        "coinbasefee": "1000000000",
        "consensus": "dpos"
    },
};